const _ = require('lodash');
const Function = require('core/src/function');
const Language = require('core/src/language').default;
const Error = require('utils/src/error');

let fetchStream = async (url, params, onData, onFinished = _.identity) => {
	try {
		const response = await fetch(url, params);
		const reader = response.body.getReader();
		const decoder = new TextDecoder('utf-8');

		while (true) {
			const { done, value } = await reader.read();

			// 'done' is true when the stream is complete
			if (done) {
				onFinished();
				break;
			}

			// 'value' is a Uint8Array containing a chunk of data
			const chunk = decoder.decode(value, { stream: true });
			onData(chunk, response.status);
		}
	} catch (error) {
		throw error;
	}

	return true;
}


const ShellExecute = Function.extend(Function, 'ShellExecute');

ShellExecute.prototype.onInit = function (dependencies) {
	this.language = dependencies.get(Language);

	this.setParameters({
		'#arguments': undefined,
		'$command': undefined,
		'$options': undefined,
		'$params': undefined,
		'$script': undefined,
		'$timeout': undefined
	});

	var notRequired = {default: undefined, warn: _.def};
	this.setModelValidation({
		command: ['isString'],
		params: ['isObject', notRequired],
	});
};

ShellExecute.prototype.onExecute = async function() {
	let res = await fetchStream(
		'/api/shell-execute',
		{
			method: 'post',
			body: JSON.stringify({
				params: this.readModel('params'), 
				id: this.id 
			}),
			headers: {
				'Content-Type': 'application/json'
			}
		},
		(data, status) => {
			if (status === 200) {
				this.executeTriggers({
					type: 'data',
					response: data,
					status: status
				});
			} else {
				this.executeTriggers({
					type: 'error',
					response: data,
					status: status
				});
			}
		}
	)
};

module.exports = ShellExecute;
